import React from "react";
import { Link } from "gatsby";

import useWindowDimensions from "../../../hooks/useWindowDimensions";

import { MenuItemTypes } from "../../../types/layout";
import MENU_PATHS from "../../../constants/menu";

const links: MenuItemTypes[] = [
  { id: 1, name: "Privacy Policy", path: MENU_PATHS.PRIVACY_POLICY },
  { id: 2, name: "Terms of service", path: MENU_PATHS.TERMS_OF_SERVICE },
];

const PrivacyCopyrightInfo = () => {
  const { isSmallScreen } = useWindowDimensions();

  return (
    <div
      className={`m-footer__privacyCopyrightInfo _12 ${
        isSmallScreen ? "column aligned-center -row-gap10" : "space-between"
      } -small -mt20`}
    >
      <div
        className={`space-between clearPadding ${
          isSmallScreen ? "-column-gap20" : "-column-gap10"
        }`}
      >
        {links.map(({ id, name, path }) => (
          <Link
            className="underline text-white clearPadding"
            key={id}
            to={path}
          >
            {name}
          </Link>
        ))}
      </div>
      <p className="text-white -privacyText">
        © 2025 Skill N Depth. All Rights Reserved.
      </p>
    </div>
  );
};

export default PrivacyCopyrightInfo;
